import { pascalToCamel, pascalToKebab } from '@owner/casing';
export const getCasing = ({ name, pluralizedName, }) => ({
    camel: pascalToCamel(name),
    kebab: pascalToKebab(name),
    pascal: name,
    pluralCamel: pascalToCamel(pluralizedName),
    pluralKebab: pascalToKebab(pluralizedName),
    pluralPascal: pluralizedName,
});
//# sourceMappingURL=casing.js.map